<div class="container-fluid mt-3 mb-3 theme">
    <div class="row nowrap mt-4 mb-3" aria-label="breadcrumb">
        <div class="col-lg-10">
            <div class="d-flex">
                <h1>Sovereign Green Bond</h1>
                <ul class="breadcrumbcustom" role="navigation" aria-labelledby="breadcrumb">
                    <li><a routerLink="">Home</a></li>
                    <li><a routerLink="/sovereignGreenBond/sgrb">Dashboard</a></li>
                    <li class="active"><a routerLink="/sovereignGreenBond/sgrb/addDeal">Deal</a></li>
                </ul>
            </div>
        </div>
    </div>
    <!-- Add Single deal body -->
    <div class="mt-2 justify-content-center ">
        <div class="card card-body colorborder">
            <form [formGroup]="tradeForm">
                <div class="col-lg-12 mt-3">
                    <h3 class="mb-2 headerFont">Deal Details</h3>
                    <div class="card card-body">
                        <div class="row">
                            <div class="col-lg-3 form-group">
                                <label>Reporting Member Name</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="reportingMemName" readonly>
                            </div>
                            <div class="col-lg-3 form-group">
                                <label>Reporting Member Id</label>
                                <input type="text" class="form-control form-control-sm" formControlName="reportingMemId"
                                    readonly>
                            </div>
                            
                            <div class="col-lg-3 form-group">
                                <label>Counter Party Name <span class="red">*</span></label>
                                <select class="form-control form-control-sm selectpicker"
                                    formControlName="countrPartyName" title="Select Counter Party"
                                    data-live-search="true" (change)="selectCounterParty()"
                                    [ngClass]="{'is-invalid': (f.countrPartyName.touched) && f.countrPartyName.touched}">
                                    <option value="" disabled>Select Counter Party</option>
                                    <option *ngFor="let data of counterPartyData" value="{{data.userName}}">
                                        {{data.entityCode +" - "+data.userName}}</option>
                                </select>
                                <p *ngIf="f.countrPartyName.invalid && f.countrPartyName.touched" class="error nocase">
                                    Please select Counter Party
                                </p>
                            </div>
                            <div class="col-lg-3 form-group">
                                <label>Counter Party Member Id</label>
                                <input type="text" class="form-control form-control-sm" formControlName="countrPartyId"
                                    readonly>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 form-group">
                                <label>Transaction Ref Id</label><!--<span class="red">*</span> -->
                                <input type="text" class="form-control form-control-sm" formControlName="txnRefId">
                            </div>
                            <div class="col-lg-3 form-group">
                                <label>Trade Date<span class="red">*</span></label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm datepicker"
                                        [maxDate]="todayDate" [(bsValue)]="bsValue[0]" formControlName="trdDate"
                                        bsDatepicker [bsConfig]="{ isAnimated: true}" placeholder="Select Trade Date"
                                        [ngClass]="{'is-invalid':  f.trdDate.touched && f.trdDate.errors}">
                                    <div class="input-group-append pointer">
                                        <span class="input-group-text">
                                            <i class="fa fa-calendar" [(bsValue)]="bsValue[0]" bsDatepicker
                                                [maxDate]="todayDate" [bsConfig]="{ isAnimated: true }"></i>
                                        </span>
                                    </div>
                                </div>
                                <p *ngIf=" f.trdDate.touched && f.trdDate.invalid" class="error">
                                    Please enter trade date
                                </p>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-3 form-group">
                                <label>Trade Time<span class="red">*</span></label>
                                <timepicker formControlName="trdTime" [showMeridian]="false" [showSeconds]="true"
                                    [showSpinners]="false"
                                    [ngClass]="{'is-invalid':   f.trdTime.touched && f.trdTime.errors}">
                                </timepicker>
                                <p *ngIf="f.trdTime.touched && f.trdTime.invalid" class="error">
                                    Please enter trade time
                                </p>
                            </div>
                            <div class="col-lg-3 form-group">
                                <label>Option Style</label><span class="red">*</span>
                                <select class="form-control form-control-sm " formControlName="optStyle"
                                    title="Select Option Style"
                                    [ngClass]="{'is-invalid': (f.optStyle.touched && f.optStyle.errors)}">
                                    <option *ngFor="let data of optionStyle" value="{{data}}">
                                        {{data}}</option>
                                </select>
                                <p *ngIf="f.optStyle.invalid && f.optStyle.touched" class="error nocase">
                                    Please select Option Style
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 form-group">
                                <label>Base Currency Code </label>
                                <input type="text" class="form-control form-control-sm" formControlName="baseCrncyCode">
                            </div>
                            <div class="col-lg-3 form-group">
                                <label>Term Currency Code </label>
                                <input type="text" class="form-control form-control-sm" formControlName="trmCrncyCode">
                            </div>
                            <div class="col-lg-3 form-group">
                                <label>Order Price</label><span class="red">*</span>
                                <input type="number" class="form-control form-control-sm" (input)="computeTradeValue()"
                                    formControlName="orderPrice">
                            </div>
                            <div class="col-lg-3 form-group">
                                <label>Quantity</label><span class="red">*</span>
                                <input type="number" class="form-control form-control-sm" (input)="computeTradeValue()"
                                    formControlName="qty">
                                <p *ngIf=" f.qty.hasError('negativeValue')" class="error">
                                    Trade Quantity cannot be negative
                                </p>
                                <p *ngIf=" f.qty.hasError('required')" class="error">
                                    Trade Quantity is required
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 form-group">
                                <label>Trade Value </label>
                                <input type="number" class="form-control form-control-sm" formControlName="trdValue">
                            </div>
                            <div class="col-lg-3 form-group">
                                <label>Settlement Date<span class="red">*</span></label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm datepicker" [minDate]="todayDate" [maxDate]="t1Date"
                                        [(bsValue)]="bsValue[1]" formControlName="settlementDate" bsDatepicker
                                        [bsConfig]="{ isAnimated: true}" placeholder="Select Settlement Date"
                                        [ngClass]="{'is-invalid':  f.settlementDate.touched && f.settlementDate.errors}">
                                    <div class="input-group-append pointer">
                                        <span class="input-group-text">
                                            <i class="fa fa-calendar"  [minDate]="t1Date" [maxDate]="todayDate" [(bsValue)]="bsValue[1]" bsDatepicker
                                                [bsConfig]="{ isAnimated: true }"></i>
                                        </span>
                                    </div>
                                </div>
                                <p *ngIf=" f.settlementDate.touched && f.settlementDate.invalid" class="error">
                                    Please enter Settlement date
                                </p>
                            </div>
                            <div class="col-lg-3 form-group">
                                <label>Remark </label>
                                <textarea type="text" class="form-control form-control-sm"
                                    formControlName="remark"></textarea>
                            </div>
                        </div>


                    </div>

                    <div *ngIf="action !== 'newOrder' && action !=='edit' ">
                        <h3 class="mb-2 headerFont mt-2">Counter Party Approval</h3>
                        <div class="card card-body">
                            <div class="row">
                                <div class="col-lg-3 form-group">
                                    <label>Comment </label>
                                    <textarea type="text" class="form-control form-control-sm"
                                        formControlName="comment"></textarea>
                                </div>
                                <div class="col-lg-3 form-group" *ngIf="(tradeFormData.dealStatus !='Submitted') ">
                                    <label>Approval Status </label>
                                    <input type="text" class="form-control form-control-sm" formControlName="processingSatus">
                                </div>
                                <div class="col-lg-3 mt-3 mb-2" *ngIf="action=='approval'">

                                    <button class="btn btn-primary" (click)="onApproval('A')"  data-toggle="modal" data-target="#approvalTrade">Approve</button>
                                    &nbsp;
                                    <button class="btn  btn-cancel" (click)="onApproval('R')" data-toggle="modal" data-target="#approvalTrade">Reject</button>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="row   mt-3 ml-2">
                        <div class="col-lg-2"  *ngIf="action == 'newOrder' || action == 'edit'">
                            <button class="btn btn-primary full-width" type="submit" [disabled]="(tradeForm.invalid )"
                                (click)="onSubmit()">Submit</button>
                        </div>
                        <div class="col-lg-2">
                            <button class="btn  btn-cancel full-width"
                                routerLink="/sovereignGreenBond/sgrb/">Back</button>
                        </div>
                    </div>
                </div>

            </form>
        </div>

    </div>
</div>
<div class="modal fade" id="approvalTrade" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLongTitle" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header card-header">
                <h5 class="modal-title ">Approval Confirmation</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="card-body">
                <p>Are you sure you want to {{approvalFlag=='A'?'Approve':'Reject'}} deal ?</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    >Close</button>

                <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="onSubmit()">
                    Confirm </button>
            </div>
        </div>
    </div>
</div>